import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import { ShipValidationResult, ShipValidationRule, ShipValidationRuleKey } from "../type";
import { buildValidationFailedResult, buildValidationSuccessfulResult } from "../util";
import { getPrintShippingDisabledTagMsg } from "@/utils/OrderTagUtils";

export default function validatePrintShippingDisabled(
    orders: OrderDTO[],
    rule: ShipValidationRule,
): ShipValidationResult {
    if (!rule[ShipValidationRuleKey.checkDisabledPrintShipping]) return buildValidationSuccessfulResult(orders);

    const errorMessage = getPrintShippingDisabledTagMsg(orders);
    return errorMessage ? buildValidationFailedResult(errorMessage) : buildValidationSuccessfulResult(orders);
}
